<template>
<div>
<ContentHeader  v-if="$store.state.questions.question"  :title="$store.state.languages.lang_phrases.soru+' '+$store.state.languages.lang_phrases.ceviriler"  :show_button="true"  icon="arrow-left" buttontype="danger" label="Listeye Geri Dön" url="QuestionlistQuestions" :urlparams="headerurlparams"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="!loading">
<div class="mt-4">

<div class="grid">

<div class="col-12 md:col-12" v-for="item in items">
<h2>{{item.language.name}}</h2>


<template v-if="$store.state.questions.question.type=='readonlytext'">

<Editor v-model="item.translation" 
editorStyle="height: 260px"
@text-change="updateInput($event,item.id)"
>

<template #toolbar>
<span class="ql-formats">
    <select class="ql-header" defaultValue="0">
        <option value="1">Heading</option>
        <option value="2">Subheading</option>
        <option value="0">Normal</option>
    </select>
</span>
<span class="ql-formats">
  <button class="ql-bold"></button>
  <button class="ql-italic"></button>
  <button class="ql-underline"></button>
</span>
 <span class="ql-formats">
    <button class="ql-list" value="ordered" type="button"></button>
    <button class="ql-list" value="bullet" type="button"></button>
    <select class="ql-align">
        <option defaultValue></option>
        <option value="center"></option>
        <option value="right"></option>
        <option value="justify"></option>
    </select>
</span>
<span class="ql-formats">
  <select class="ql-color" defaultValue="0">
  </select>
  <select class="ql-background" defaultValue="0">
  </select>

</span>
 <span class="ql-formats">
    <button class="ql-link" type="button"></button>
</span>
  </template>

</Editor>







</template>
<template v-else>
<ClickEditInputText  title="Soru" :value="item.translation" valkey="translation" @dataChanged="dataChanged($event,item.id)" />
</template>
<ClickEditInputTextArea  title="Yardım Metni" :value="item.description" valkey="description" @dataChanged="dataChanged($event,item.id)" />
<ClickEditInputRichTextArea  title="Alt Metin" :value="item.secondary_text" valkey="secondary_text" @dataChanged="dataChanged($event,item.id)" />





<template v-if="$store.state.questions.question.ask_for_submission_note">
  <ClickEditInputText  title="Kayıt Notu Başlık" :value="item.submission_note" valkey="submission_note" @dataChanged="dataChanged($event,item.id)" />
</template>
</div>


</div>
</div>
</template>

</div>
</template>

<script>
export default {

  name: 'QuestionTranslations',

  data () {
    return {
    	items:[],
    	loading:true,
      intervalobj:null,
    }
  },
  computed:{
    headerurlparams()
    {
      return {id:this.$store.state.questions.question.questionlist_id}
    }
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
    {
        this.items = await this.generalApiGetWithoutLoader("questionlists/inputfield/translations/"+this.$route.params.id)
        console.log(this.items)

        this.loading = await false
    }, 
    updateInput(data,id)
    {
      console.log(id);
      console.log(data)
      clearInterval(this.intervalobj);
      this.intervalobj = setInterval(()=>{
        let the_data = {value:data.htmlValue,key:"translation"}
        this.dataChanged(the_data,id)
      },1000)
    },
    dataChanged(data,id)
    {
      clearInterval(this.intervalobj);
      console.log(id);
      console.log(data)
      let formdata = new FormData()
      formdata.append(data.key,data.value)      
      this.generalSubmission(formdata,"questionlists/inputfield/translations/"+id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      console.log("data changed");
      console.log(response);      
      this.items = response.data
      
    },
  }
};
</script>

<style lang="css" scoped>
</style>